"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var aws_amplify_1 = require("aws-amplify");
var client_cognito_sync_1 = require("@aws-sdk/client-cognito-sync");
var aws_exports_1 = __importDefault(require("../aws-exports"));
var CognitoSyncManager = /** @class */ (function () {
    function CognitoSyncManager(credentials) {
        this.syncQueue = [];
        this.identityPoolId = aws_exports_1.default.Auth.identityPoolId;
        this.data = {};
        this.syncTokens = {};
        this.eventHandlers = [];
        this.identityId = credentials.identityId;
        this.deviceId = Date.now() + "-" + Math.floor(Math.random() * 1000000);
        this.client = new client_cognito_sync_1.CognitoSync({
            region: "eu-west-1",
            credentials: aws_amplify_1.Auth.essentialCredentials(credentials),
        });
        this.client.registerDevice;
        this.populateSyncQueue();
    }
    CognitoSyncManager.localStorageKey = function (dataset) {
        return "CSM-" + dataset;
    };
    CognitoSyncManager.fetchStorageValues = function (dataset) {
        var storageValue = localStorage.getItem(this.localStorageKey(dataset));
        if (storageValue !== null) {
            return JSON.parse(storageValue);
        }
        return undefined;
    };
    CognitoSyncManager.setStorageValues = function (dataset, values) {
        localStorage.setItem(this.localStorageKey(dataset), JSON.stringify(values));
    };
    /**
     *
     * @param dataset
     * @deprecated Don't use it. We have no device management this is why this function will not work
     */
    CognitoSyncManager.prototype.subscribe = function (dataset) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.client.subscribeToDataset({
                    DatasetName: dataset,
                    IdentityId: this.identityId,
                    IdentityPoolId: this.identityPoolId,
                    DeviceId: this.deviceId,
                }, function (err, data) {
                    console.log("subscription", { data: data, err: err });
                    _this.fetchRecords(dataset);
                });
                return [2 /*return*/];
            });
        });
    };
    /**
     *
     * @param dataset
     * @deprecated Don't use it. We have no device management this is why this function will not work
     */
    CognitoSyncManager.prototype.unsubscribe = function (dataset) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.client
                    .unsubscribeFromDataset({
                    DatasetName: dataset,
                    IdentityId: this.identityId,
                    IdentityPoolId: this.identityPoolId,
                    DeviceId: this.deviceId,
                })
                    .catch(function (error) {
                    console.error(error);
                });
                return [2 /*return*/];
            });
        });
    };
    CognitoSyncManager.prototype.addListener = function (dataset, key, callback) {
        this.eventHandlers.push({ key: key, dataset: dataset, callback: callback });
    };
    CognitoSyncManager.prototype.removeListener = function (dataset, key, callback) {
        this.eventHandlers = this.eventHandlers.filter(function (entry) {
            return entry.key !== key &&
                entry.callback !== callback &&
                entry.dataset === dataset;
        });
    };
    CognitoSyncManager.prototype.informListerners = function (dataset, key, value, isCurrentlyLocalState) {
        var _a, _b, _c, _d;
        if (isCurrentlyLocalState === void 0) { isCurrentlyLocalState = false; }
        if (key !== undefined) {
            var listenersToInform = this.eventHandlers.filter(function (handler) { return handler.dataset === dataset && handler.key === key; });
            for (var _i = 0, listenersToInform_1 = listenersToInform; _i < listenersToInform_1.length; _i++) {
                var _e = listenersToInform_1[_i], key_1 = _e.key, callback = _e.callback;
                callback(value !== false ? value : (_b = (_a = this.data[dataset]) === null || _a === void 0 ? void 0 : _a[key_1]) === null || _b === void 0 ? void 0 : _b.value, isCurrentlyLocalState);
            }
        }
        else {
            var listenersToInform = this.eventHandlers.filter(function (handler) { return handler.dataset === dataset; });
            for (var _f = 0, listenersToInform_2 = listenersToInform; _f < listenersToInform_2.length; _f++) {
                var _g = listenersToInform_2[_f], key_2 = _g.key, callback = _g.callback;
                callback(value !== false ? value : (_d = (_c = this.data[dataset]) === null || _c === void 0 ? void 0 : _c[key_2]) === null || _d === void 0 ? void 0 : _d.value, isCurrentlyLocalState);
            }
        }
    };
    CognitoSyncManager.getLocalStorage = function (dataset, key) {
        var _a;
        var localDataset = this.fetchStorageValues(dataset);
        return (_a = localDataset === null || localDataset === void 0 ? void 0 : localDataset[key]) === null || _a === void 0 ? void 0 : _a.value;
    };
    CognitoSyncManager.prototype.get = function (dataset, key) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if ((_a = this.data[dataset]) === null || _a === void 0 ? void 0 : _a[key]) {
                            return [2 /*return*/, (_b = this.data[dataset][key]) === null || _b === void 0 ? void 0 : _b.value];
                        }
                        return [4 /*yield*/, this.fetchRecords(dataset)];
                    case 1:
                        _e.sent();
                        return [2 /*return*/, (_d = (_c = this.data[dataset]) === null || _c === void 0 ? void 0 : _c[key]) === null || _d === void 0 ? void 0 : _d.value];
                }
            });
        });
    };
    CognitoSyncManager.prototype.fetchRecords = function (dataset, notify) {
        var _a;
        if (notify === void 0) { notify = true; }
        return __awaiter(this, void 0, void 0, function () {
            var cachedFetch, fetch, data, formattedData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cachedFetch = CognitoSyncManager.dataSetCalls[dataset];
                        if (cachedFetch) {
                            fetch = cachedFetch;
                        }
                        else {
                            fetch = this.client.listRecords({
                                MaxResults: 1000,
                                DatasetName: dataset,
                                IdentityId: this.identityId,
                                IdentityPoolId: this.identityPoolId,
                            });
                            CognitoSyncManager.dataSetCalls[dataset] = fetch;
                        }
                        return [4 /*yield*/, fetch];
                    case 1:
                        data = _b.sent();
                        formattedData = (_a = data.Records) === null || _a === void 0 ? void 0 : _a.reduce(function (result, record) {
                            var Key = record.Key, Value = record.Value, SyncCount = record.SyncCount;
                            if (Key === undefined || Value === undefined || SyncCount === undefined)
                                return result;
                            result[Key] = { value: Value, syncCount: SyncCount };
                            return result;
                        }, {});
                        if (formattedData !== undefined) {
                            this.data[dataset] = formattedData;
                            CognitoSyncManager.setStorageValues(dataset, formattedData);
                        }
                        this.syncTokens[dataset] = {
                            token: data.SyncSessionToken,
                            syncCount: data.DatasetSyncCount,
                        };
                        if (notify) {
                            this.informListerners(dataset, undefined, false);
                        }
                        return [2 /*return*/, formattedData];
                }
            });
        });
    };
    CognitoSyncManager.prototype.populateSyncQueue = function () {
        var value = localStorage.getItem(CognitoSyncManager.SyncQueueKey);
        if (value !== null) {
            this.syncQueue = JSON.parse(value);
            for (var _i = 0, _a = this.syncQueue; _i < _a.length; _i++) {
                var entry = _a[_i];
                var dataset = entry.dataset, key = entry.key, value_1 = entry.value;
                console.log("was offline try to update again", { dataset: dataset, key: key, value: value_1 });
                this.removeSync(dataset, key);
                this.updateRecord(dataset, key, value_1);
            }
        }
    };
    CognitoSyncManager.prototype.addSync = function (dataset, key, value) {
        this.removeSync(dataset, key);
        this.syncQueue.push({ dataset: dataset, key: key, value: value });
        localStorage.setItem(CognitoSyncManager.SyncQueueKey, JSON.stringify(this.syncQueue));
    };
    CognitoSyncManager.prototype.removeSync = function (dataset, key) {
        this.syncQueue = this.syncQueue.filter(function (entry) { return dataset !== entry.dataset && key !== entry.key; });
        localStorage.setItem(CognitoSyncManager.SyncQueueKey, JSON.stringify(this.syncQueue));
    };
    CognitoSyncManager.prototype.updateRecord = function (dataset, key, value) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var kb, error_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.informListerners(dataset, key, value, true);
                        kb = new Blob([value || ""]).size / 1024;
                        if (kb > 30) {
                            console.warn("The user defaults are not a database. Your current key only has more than 30KB of text size. This datasets quota is just 1MB. Do not save to big entries");
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 5, , 6]);
                        delete CognitoSyncManager.dataSetCalls[dataset];
                        return [4 /*yield*/, this.fetchRecords(dataset, false)];
                    case 2:
                        _e.sent();
                        return [4 /*yield*/, this.client.updateRecords({
                                DeviceId: this.deviceId,
                                IdentityId: this.identityId,
                                IdentityPoolId: this.identityPoolId,
                                DatasetName: dataset,
                                SyncSessionToken: (_a = this.syncTokens[dataset]) === null || _a === void 0 ? void 0 : _a.token,
                                RecordPatches: [
                                    {
                                        Key: key,
                                        Value: value,
                                        Op: value === undefined ? "remove" : "replace",
                                        SyncCount: ((_c = (_b = this.data[dataset]) === null || _b === void 0 ? void 0 : _b[key]) === null || _c === void 0 ? void 0 : _c.syncCount) ||
                                            ((_d = this.syncTokens[dataset]) === null || _d === void 0 ? void 0 : _d.syncCount),
                                    },
                                ],
                            })];
                    case 3:
                        _e.sent();
                        delete CognitoSyncManager.dataSetCalls[dataset];
                        return [4 /*yield*/, this.fetchRecords(dataset)];
                    case 4:
                        _e.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _e.sent();
                        console.error("update not working, sending it to sync queue", error_1);
                        this.addSync(dataset, key, value);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CognitoSyncManager.SyncQueueKey = "CSM-SYNC-QUEUE";
    CognitoSyncManager.dataSetCalls = {};
    return CognitoSyncManager;
}());
exports.default = CognitoSyncManager;
//# sourceMappingURL=CognitoSyncManager.js.map